document.addEventListener('DOMContentLoaded', function(){
      const targetImage = document.querySelector('.video-image-slider-wrapper-template--18988364726517__ss_video_image_text_3_fXTTFq .swiper-fade .swiper-slide-active ');
      if (targetImage) {
        targetImage.addEventListener('click', function() {
            window.location.href = 'https://thespiralpath.love/products/stardust-wheel'; 
        });
    }
const swiperContainer = document.querySelector('.video-image-slider-wrapper-template--18988364726517__ss_video_image_text_3_aKpyja');

if (swiperContainer) {
    swiperContainer.addEventListener('click', function(event) {
        const swiperImage = swiperContainer.querySelector('.swiper-slide-active');
        if (swiperImage && swiperImage.contains(event.target)) {
            const linkElement = document.querySelector('.video-image-item-template--18988364726517__ss_video_image_text_3_aKpyja.active');
            if (linkElement) {
                const href = linkElement.getAttribute('href');
                window.location.href = href;
            }
        }
    });
}
   
})

